import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { showError } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
import useLastModifications from '../useLastModification';
type useRequirementsProps = {
  networkId: string | undefined;
};
export const useRequirements = t0 => {
  const $ = _c(13);
  const {
    networkId
  } = t0;
  const {
    data: lastModifications
  } = useLastModifications(networkId);
  const t1 = networkId as string;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      networkId: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !!networkId && !!lastModifications?.requirement;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      enabled: t3,
      placeholderData: keepPreviousData
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    data: requirements,
    isLoading,
    isFetched,
    isPlaceholderData,
    refetch,
    error
  } = trpc.assumptionSet.getRequirements.useQuery(t2, t4);
  let t5;
  let t6;
  if ($[4] !== error) {
    t5 = () => {
      if (error) {
        showError("Failed to load requirements.", {
          description: "Check your internet connection and try again."
        });
      }
    };
    t6 = [error];
    $[4] = error;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== isFetched || $[8] !== isLoading || $[9] !== isPlaceholderData || $[10] !== refetch || $[11] !== requirements) {
    t7 = {
      data: requirements,
      isLoading,
      isFetched,
      isPlaceholderData,
      refetch
    };
    $[7] = isFetched;
    $[8] = isLoading;
    $[9] = isPlaceholderData;
    $[10] = refetch;
    $[11] = requirements;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default useRequirements;